/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { createEnum, EnumSet } from '@gh/core-data';

export const CustomFieldPlacement = createEnum('CUSTOM_FIELD_PLACEMENT', {
  ContactCreditorSupplierTab: 'CONTACT_CREDITOR_SUPPLIER_TAB',
  ContactCustomerTab: 'CONTACT_CUSTOMER_TAB',
  ContactDebtorTab: 'CONTACT_DEBTOR_TAB',
  ContactEmployeeTab: 'CONTACT_EMPLOYEE_TAB',
  ContactFinanceCompanyTab: 'CONTACT_FINANCE_COMPANY_TAB',
  ContactCityCountyTab: 'CONTACT_CITY_COUNTY_TAB',
  ContactOtherTab: 'CONTACT_OTHER_TAB',
});

export type CustomFieldPlacement = EnumSet<typeof CustomFieldPlacement>;
